import './page_thumbnail.less';

import React, { Fragment } from 'react';

import { 
  LoadingIcon,
  ZoomforthLogoIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';

const PageThumbnail = ({ isPlaceholder, screenshotUrl, showTipsy, tipsyPlacement })=> (
  <div className="page-preview-thumbnail">
    {
      isPlaceholder ?
        <ZoomforthLogoIcon />
      : (screenshotUrl) ?
        <Fragment>
          <div className="thumbnail-loading-container">
            <LoadingIcon />
          </div>
          <SafeTipsy 
            mouseEnterDelay={0.1}
            placement={tipsyPlacement}
            content={showTipsy && <img src={screenshotUrl} />}
          >
            <img src={screenshotUrl} />
          </SafeTipsy>
        </Fragment>
      :
        <ZoomforthLogoIcon />
    }
  </div>
);

PageThumbnail.defaultProps = {
  showTipsy: true,
  tipsyPlacement: 'bottom'
};

export default PageThumbnail;
